import { render, staticRenderFns } from "./Settings_Module.vue?vue&type=template&id=6a3568c2&scoped=true"
import script from "./Settings_Module.vue?vue&type=script&lang=js"
export * from "./Settings_Module.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a3568c2",
  null
  
)

export default component.exports